import { useState } from 'react'
import "./whatsHappening.css"
import EnquiryForm from '../EnquiryForm/EnquiryForm'

const WhatsHappening = () => {

     const [showModal,setShowModal] = useState(false)

    const events = [
        {
            title: 'Join our upcoming beach yoga workshop on 15th Jan, 2026',
            description: 'Aenean eleifend ante maecenas pulvinar montes lorem et pede dis dolor pretium donec dictum. Vici consequat justo enim. Venenatis eget',
            img: './assets/beach-yoga.png'
        },
        {
            title: 'Yoga Camp – Unite your Body, Breath and Mind',
            description: 'Aenean eleifend ante maecenas pulvinar montes lorem et pede dis dolor pretium donec dictum. Vici consequat justo enim. Venenatis eget',
            img: './assets/summer-camp.png'
        },
        {
            title: 'Announcement - International Yoga Day 2026 Contest',
            description: 'Aenean eleifend ante maecenas pulvinar montes lorem et pede dis dolor pretium donec dictum. Vici consequat justo enim. Venenatis eget',
            img: './assets/international-yoga.png'
        }

    ]
    
  return (
    <>
    <div className="whatsHappening-container">
        <div className="whatsHappening-wrapper">
            <div className="whatsHappening-heading text-center">
                <h2>What's Happening</h2>
            </div>

            <div className="whatsHappening-events mt-4">
                {
                    events.map((event, index) => (  
                        <div key={index} className="event-card">
                            <div className="event-card-img">
                                <img src={event.img} alt={event.title} />   
                            </div>
                            <div className="event-card-content">
                                <h5>{event.title}</h5>  
                                <p>{event.description}</p>
                                <h6 onClick={()=>setShowModal(true)}>Register Now</h6>
                            </div>
                        </div>      
                    ))
                }
            </div>
            
        </div>
    </div>
    {
        showModal && <EnquiryForm title={'Book Your Free Trial Today!'} setEnquiryPopUp={setShowModal}/>
    }
    </>
  )
}

export default WhatsHappening